import request from '@/utils/request'

// 生存环境

// 搜索
export function search (data) {
  return request({
    data: data,
    url: '/old/searchexpertnew',
    method: 'post'
  })
}

// 发送邮件
export function getMsg (data) {
  return request({
    data: data,
    url: '/old/api/contactmail',
    method: 'post'
  })
}

// 获取用户信息
export function getUser (params) {
  return request({
    params: params,
    url: '/old/api/User',
    method: 'post'
  })
}

// 退出
export function logout () {
  return request({
    url: '/logout',
    method: 'get'
  })
}

// 获取省
export function getPro (data) {
  return request({
    url: '/api/Area/Query',
    data: data,
    method: 'post'
  })
}

// 开发环境
// export function search (data) {
//   return request({
//     data: data,
//     url: '/test/searchexpertnew',
//     method: 'post'
//   })
// }

// export function getMsg (data) {
//   return request({
//     data: data,
//     url: 'test/api/contactmail',
//     method: 'post'
//   })
// }

// export function getUser (params) {
//   return request({
//     params: params,
//     url: '/test/api/User',
//     method: 'post'
//   })
// }
// export function logout () {
//   return request({
//     url: 'test/old/logout',
//     method: 'get'
//   })
// }

// // 获取省
// export function getPro (data) {
//   return request({
//     url: 'test/api/Area/Query',
//     data: data,
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/common.js